import React, { useState, useLayoutEffect, useEffect } from "react"
import PropTypes from "prop-types"
import styles from "./Layout.module.scss"
import SEO from "../seo"
import avatarMini from "../../assets/images/avatar-mini.jpg"

const Layout: React.FC<any> = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState<boolean | undefined>(undefined)

  useLayoutEffect(() => {
    window.scrollTo(0, 0)
    // Query whether the user prefers dark mode or not
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)")
    setIsDarkMode(prefersDark.matches || false)
  }, [])

  useEffect(() => {
    if (isDarkMode === undefined) return // initial mount
    // Adds class name to root HTML element.
    const className = `theme-${isDarkMode ? "dark" : "light"}`
    document.documentElement.className = ""
    document.documentElement.classList.add(className)
  }, [isDarkMode])

  return (
    // TODO: UPDATE HELMET
    <>
      <SEO title="App Design and Development. Product Management." />
      <main>
        <nav className={`${styles.nav} theme-nav`}>
          <div>
            <img src={avatarMini} alt="Matthew Frawley Avatar" />
            <span>Matthew Frawley</span>
          </div>
          <button onClick={() => setIsDarkMode(prev => !prev)}>
            {isDarkMode ? "Go Light" : "Go Dark"}
          </button>
        </nav>
        <div>{children}</div>
      </main>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
